import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigLoadError } from './startup-failure';

export type AppConfig = Record<string, any>;

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public readonly $configuration = new BehaviorSubject<AppConfig>({});

  constructor(private http: HttpClient) { }

  load(url = '/assets/config.json'): Promise<void> {
    return this.http.get<AppConfig>(url).toPromise()
      .then(cfg => {
        this.$configuration.next(cfg || ({} as AppConfig));
      })
      .catch(err => {
        throw new ConfigLoadError(err);
      });
  }

  getEnvironment() {
    return this.$configuration.value.environment;
  }
}
